// extracted by mini-css-extract-plugin
export default {"body":"kfEZQYhxjRNIDXZRWIdI","article":"X9fHrnfVZNTXfaljA6Pq"};